module.exports = __webpack_public_path__ + "static/img/ni.7b131ab3.svg";